import { FC } from 'react';
import { ProductBadgesList } from '../ProductBadgesList';
import { useParams } from 'react-router-dom';

export const ProductBadgesTab: FC = () => {
  const { id: tenantId, modelId } = useParams();

  return <ProductBadgesList tenantId={String(tenantId)} modelId={String(modelId)} />;
};
